// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"freebie_wrapper__041IH","title":"freebie_title__7sNhU"};